import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { restrictedContent as restrictedContentImage } from '@atlassian/company-hub-common/assets';

import { CARDS_EXTENSION_ANALYTIC_SOURCE, CARDS_EXTENSION_TYPE } from '../../../../../constants';
import { ErrorState } from '../error-state';
import type { CommonCardErrorStateProps } from '../index';
import { SmallCardErrorState } from '../small-card-error-state';

import { messages } from './messages';

export type RestrictedContentErrorStateProps = {
	link?: string;
} & CommonCardErrorStateProps;

export const RestrictedContent = ({
	cardId,
	cardSize,
	cardHeight,
	link,
	isInViewMode,
	errorStatus,
}: RestrictedContentErrorStateProps): React.JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendOperationalEvent',
			data: {
				source: CARDS_EXTENSION_ANALYTIC_SOURCE,
				action: 'error',
				actionSubject: 'restricted',
				attributes: {
					extensionType: CARDS_EXTENSION_TYPE,
					error: errorStatus,
					isInViewMode,
				},
			},
		}).fire();
	}, [createAnalyticsEvent, errorStatus, isInViewMode]);

	switch (cardSize) {
		case 'small':
			return (
				<SmallCardErrorState
					itemId={cardId}
					link={link}
					image={restrictedContentImage}
					heading={messages.restrictedContent}
					subheading={messages.restrictedContentButtonLabel}
					height={cardHeight}
					isInViewMode={isInViewMode}
				/>
			);
		default:
			return (
				<ErrorState
					itemId={cardId}
					link={link}
					heading={messages.restrictedContent}
					description={messages.restrictedContentDescription}
					primaryAction={messages.restrictedContentButtonLabel}
					image={restrictedContentImage}
					itemHeight={cardHeight}
					isInViewMode={isInViewMode}
				/>
			);
	}
};
